import { Operator } from '@wf/components';

import { Operators } from '../@types/serviceTypes';

import { COUNTRY } from '../config';

export const APP_NAME = 'LPCO2_CLIENT';

export const PAGE_CONTENT_ID = 'page-content';

export const PAGINATION_LIMIT = 20;
export const DEFAULT_PAGE_SIZE = 10;

export enum SortDirection {
  DESC = 'DESC',
  ASC = 'ASC',
}

export enum LpcoRole {
  TRADER = 'ROLE_LPCO2_TRADER',
  DECLARANT = 'ROLE_LPCO2_DECLARANT',
  OFFICER = 'ROLE_LPCO2_OFFICER',
  SENIOR_OFFICER = 'ROLE_LPCO2_SENIOR_OFFICER',
  CASHIER = 'ROLE_LPCO2_CASHIER',
  VIEWER = 'ROLE_LPCO2_VIEWER',
  ADMINISTRATOR = 'ROLE_LPCO2_ADMINISTRATOR',
}

export const declarantRoles = {
  lpco2_client: [LpcoRole.DECLARANT],
};

export const viewRoles = {
  lpco2_client: [
    LpcoRole.TRADER,
    LpcoRole.DECLARANT,
    LpcoRole.OFFICER,
    LpcoRole.SENIOR_OFFICER,
    LpcoRole.CASHIER,
    LpcoRole.VIEWER,
    LpcoRole.ADMINISTRATOR,
  ],
};

export const declarantAndTraderRoles = {
  lpco2_client: [LpcoRole.DECLARANT, LpcoRole.TRADER],
};

export const updateRoles = {
  lpco2_client: [LpcoRole.TRADER, LpcoRole.DECLARANT, LpcoRole.OFFICER, LpcoRole.SENIOR_OFFICER, LpcoRole.CASHIER],
};

export const officerRoles = {
  lpco2_client: [LpcoRole.OFFICER, LpcoRole.SENIOR_OFFICER],
};

export const officerAndAdminRoles = {
  lpco2_client: [LpcoRole.OFFICER, LpcoRole.SENIOR_OFFICER, LpcoRole.ADMINISTRATOR],
};

export const dateRangeFieldOperators = {
  [Operator.dateRange]: Operators.BETWEEN,
  [Operator.exactDate]: Operators.EQUALS,
  [Operator.beforeTheDate]: Operators.LESS_THAN,
  [Operator.afterTheDate]: Operators.GREATER_THAN,
};

export const lpcoAbbreviation = COUNTRY === 'bangladesh' ? 'CLP' : 'LPCO';

export enum FileType {
  JPG = 'JPG',
  JPEG = 'JPEG',
  PNG = 'PNG',
  XLSX = 'XLSX',
  PDF = 'PDF',
  JSON = 'JSON',
}

export enum ItemsQueryParams {
  itemIndex = 'itemIndex',
}
